// eslint-disable-next-line import/prefer-default-export
export const IDENTITY_SSO_REDIRECT_DEFAULT =
  'Please DO NOT press Back or Reload this Page. Please wait...';

export const INVALID_COMPANY_NAME_ERROR =
  'Sorry, company name cannot contain http or https';
